export class Facility {
  constructor(
    readonly id: string,
    readonly name: string,
  ) {}
}
